import { initModules, loadScript } from "utils";
import LazyLoader from "./utils/lazyLoading/lazyLoader";
import LazyElements from "./utils/lazyLoading/lazyElements";
import SmoothScroll from "./utils/smooth-scroll";
import ScrollAnimations from "./utils/scrollAnimations";

// Import individual modules here
import Accordion from "modules/accordion";
import Countdown from "modules/countdown";
import Sticky from "modules/sticky";
import Map from "modules/google-map";
import ScrollTop from "modules/scroll-top";
import TextCopy from "modules/text-copy";
import Tabs from "modules/tabs";
import Modal from "./modules/modal";
import ComparisonTable from "./modules/comparisonTable";
import SyntaxHighlighter from "./modules/syntaxHighlighter";
import Expandable from "./modules/expandable";
import VerticalTab from "./modules/verticalTab";
import HorizontalTab from "./modules/horizontalTab";
import JobOverview from "./modules/job-overview";
import Dropdown from "./modules/dropdown";
import FeaturesTable from "./modules/featuresTable";
import HoldersOverview from "./modules/holdersOverview";
import Tippy from "./modules/tippy";
import DamVideo from "./modules/damVideo";
import AudioPlayer from "./modules/audio-player";
import Slider from "./modules/slider";
import LottiePlayer from "./modules/lottie-player";
import ExtensionForm from "./modules/marketo/extensionForms/index";
import EmbeddedForm from "./modules/marketo/embeddedForms/index";
import Ads from "./modules/ads";
import ParallaxContainer from "./modules/parallaxContainer";
import ReferencesHero from "./modules/referencesHero";
import SplitScroll from "./modules/splitScroll";
import App from "./modules/app";
import initAccessibility from "./modules/accessibility";
import ChapterNav from "./modules/chapter-navigation";
import PersonalizationScript from "./modules/personalization-script";

window.addEventListener("load", function() {
    ScrollAnimations();
    SmoothScroll();
    LazyLoader(".e-in", { rootMargin: "-25px", threshold: 0 }, LazyElements);
    initModules({
        Ads,
        Accordion,
        Countdown,
        Sticky,
        Map,
        ScrollTop,
        TextCopy,
        Tabs,
        Modal,
        ComparisonTable,
        SyntaxHighlighter,
        Expandable,
        VerticalTab,
        HorizontalTab,
        JobOverview,
        Dropdown,
        FeaturesTable,
        HoldersOverview,
        Tippy,
        DamVideo,
        AudioPlayer,
        Slider,
        ExtensionForm,
        ParallaxContainer,
        ReferencesHero,
        SplitScroll,
        App,
        ChapterNav,
    });

    loadScript(
        "https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie_light_canvas.min.js",
        document.querySelector(".js-module-lottie-player")
    )
        .then(() => initModules({ LottiePlayer }))
        .catch(() => {});

    loadScript(
        "/.resources/corpweb2021/webresources/dist/search.js?202411060909",
        document.querySelector("#v-search")
    ).catch(() => {});

    EmbeddedForm();
    initAccessibility();
    PersonalizationScript();
});
